import React from 'react'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import { Flex, ThemeSwitcher, useMatchBreakpoints } from '@pancakeswap/uikit'
import useTheme from 'hooks/useTheme'
import { SIGNIN_LINK } from 'config/constants/links'

const networks = {
  bsc: {
    name: 'BSC Mainnet',
    href: 'https://bsc.ncx.cx',
    chainId: 56,
  },
  eth: {
    name: 'Ethereum',
    href: 'https://eth.ncx.cx',
    chainId: 1,
  },
}

const StyledSwitch = styled.div`
  position: relative;
  background: transparent;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.text};
  padding: 2px 5px !important;
  font-size: 13px;
  cursor: pointer;
  padding-right: 20px !important;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 5px;
  height: 32px;
  border: 1px solid #aaa; //${({ theme }) => theme.colors.text};
  .bar {
    display: inline-block;
    width: 0;
    height: 20px;
    border-left: 1px solid #aaa;
  }

  @media (max-width: 575px) {
    margin-right: 0;
    min-width: 10px !important;
    font-size: 12px;
  }

  &:after {
    content: '';
    position: absolute;
    border-width: 7px 5px 0 5px;
    border-color: ${({ theme }) => theme.colors.text} transparent transparent transparent;
    border-style: solid;
    top: 13px;
    right: 6px;
  }

  .dropdown {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
    top: 30px;
    right: 0;
    z-index: 1000;
    padding-top: 10px;
    transition: 0.5s;

    &-inner {
      background: ${({ theme }) => theme.colors.background};
      box-shadow: 0 0 6px 4px ${({ theme }) => theme.colors.cardBorder};
      border-radius: 7px;
    }

    a {
      display: block;
      padding: 10px 0 10px 10px;
      text-align: left;
      margin: 0;
      color: ${({ theme }) => theme.colors.text};

      @media (max-width: 575px) {
        font-size: 12px;
      }

      &.disabled {
        color: ${({ theme }) => theme.colors.textSubtle};
        pointer-events: none;
      }
    }

    a + a {
      // border-top: 1px solid #222;
    }

    @media (max-width: 575px) {
      bottom: auto;
      top: -100px;
    }
  }

  &:hover {
    .dropdown {
      opacity: 1;
      pointer-events: all;
    }
  }
`

const NetworkSwitch = ({ chain, isLabelShow = false }) => {
  const { isMobile } = useMatchBreakpoints()
  return (
    <StyledSwitch className="btn-xao-md" style={{ maxWidth: 135 }}>
      <img src={`/images/chains/${networks[chain].chainId}.png`} width="26px" height="26px" alt="chain-logo" />
      {!isMobile || isLabelShow ? networks[chain].name : ''}
      <div className="dropdown">
        <div className="dropdown-inner shadow-xao">
          {Object.keys(networks).map((k) => (
            <a
              key={k}
              href={networks[k].href}
              className={k === chain ? 'disabled' : ''}
              style={{ display: 'flex', alignItems: 'center', gap: 5 }}
            >
              <img src={`/images/chains/${networks[k].chainId}.png`} width="24px" height="24px" alt="chain-logo" />
              {!isMobile || isLabelShow ? networks[k].name : ''}
            </a>
          ))}
        </div>
      </div>
    </StyledSwitch>
  )
}

export default NetworkSwitch

export const GlobalMenu = () => {
  const { isDark, toggleTheme } = useTheme()
  return (
    <Flex justifyContent="center" alignItems="center" style={{ gap: 5 }}>
      <ThemeSwitcher isDark={isDark} toggleTheme={toggleTheme} />
      <Button href={SIGNIN_LINK} target="_self" className={`signin ${isDark ? 'dark' : ''}`} rel="noreferrer">
        Sign In
      </Button>
      <Button href={SIGNIN_LINK} target="_self" className={`signin ${isDark ? 'dark' : ''}`} rel="noreferrer">
        DeFi
      </Button>
      {/* <NetworkSwitch chain={chain} /> */}
    </Flex>
  )
}